module.exports = __webpack_public_path__ + "img/skunk.1e75c066.png";